export class GenericFilter {
  atributos?: any;
  clase?: string;
  claseUsuario?: string;
  pagina?: number;
  tamPagina?: number;
  ordenacion?: any;

  constructor(
    data: {
      atributos?: any;
      clase?: string;
      claseUsuario?: string;
      pagina?: number;
      tamPagina?: number;
      ordenacion?: any;
    } = {}
  ) {
    this.atributos = data.atributos || {};
    // this.clase = data.clase || '';
    this.clase = data.clase;
    // this.claseUsuario = data.claseUsuario || '';
    this.claseUsuario = data.claseUsuario;
    this.pagina = data.pagina || 0;
    this.tamPagina = data.tamPagina || 10;
    this.ordenacion = data.ordenacion;
  }
}
